import { Zap } from 'lucide-react';
import { BuyerIntentEvent as BuyerIntentEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: BuyerIntentEventType;
}

export default function BuyerIntentEvent({ event }: Props) {
  return (
    <EventShell
      color="orange"
      icon={<Zap className="w-3.5 h-3.5" />}
      title="Buyer Intent Detected"
      timestamp={event.created_at}
    >
      <p>{event.payload.reason}</p>
      {event.payload.signal_source && <p>Source: {event.payload.signal_source}</p>}
    </EventShell>
  );
}
